function eventInjection() {
    var callbacks = {};
    var allowedOrigins = (window._ab && window._ab.allowedOrigins) || window.__abAllowedOrigins || '*';
    var targetOrigin = (window._ab && window._ab.targetOrigin) || '*';

    function isAllowedOrigin(origin, allowlist) {
      if (!allowlist || allowlist === '*') {
        return true;
      }

      if (!origin) {
        return false;
      }

      if (Array.isArray(allowlist)) {
        return allowlist.indexOf(origin) > -1;
      }

      return allowlist === origin;
    }

    function safeParseMessage(message) {
      if (!message || typeof message.data !== 'string') {
        return null;
      }

      if (!isAllowedOrigin(message.origin, allowedOrigins)) {
        return null;
      }

      try {
        var parsed = JSON.parse(message.data);
        if (!parsed || typeof parsed.action !== 'string') {
          return null;
        }
        return parsed;
      } catch (e) {
        return null;
      }
    }

    window.addEventListener(
      'message',
      message => {
        // if (event.origin !== "https://app2.abtasty.com") return;
        const messageData = safeParseMessage(message);
        if (!messageData) {
          return;
        }
  
        if(messageData.action !== 'event'){
          return;
        }
  
        var eventInfo = messageData.data;
        var event = eventInfo.event;

        if (event) {
          if (event === "httpError" && window.parent !== window) {
            window._ab.events.emit("httpError", eventInfo.data);
          }

          if (event === "updateToken" && eventInfo.data.accessToken && window._ab) {
            window._ab.accessToken = eventInfo.data.accessToken;
          }

          var callbacksEvent = callbacks[event];
          if (!callbacksEvent || !callbacksEvent.length) {
            return;
          }
          callbacksEvent.forEach((cb) => {
            cb(eventInfo.data);
          })
        }
      },
      false,
    );
  
    function on(event, callback) {
      callbacks[event] = callbacks[event] || [];
      callbacks[event].push(callback);
    }

    function remove(event, callback) {
      callbacks[event] = callbacks[event] || [];
      const index = callbacks[event].indexOf(callback);
      
      if (index !== -1) {
        callbacks[event].splice(index, 1);
      }
    }
  
    function emit(event, data){
      window.parent.postMessage(
        JSON.stringify({
          action: "event", 
          data: {
            "event": event,
            "data": data
          }
        }),
        targetOrigin,
      );
    }
  
    return {
      on,
      remove,
      emit
    };
  }
  
  export default eventInjection;
  
